export default {
  label: {
    rename: 'Rename',
    duplicate: 'Duplicate',
    delete: 'Delete',
  },
};
